import React from 'react';
import $ from 'jquery';
import BaseClass from '@/pages/BaseClass';
import {CommonValue, pcUrl} from '@/utils/tools';

export default class AiReport extends BaseClass {
    constructor(props) {
        super(props);
        this.state = {
            courseId: 0,
            reportName: "",
            data: "",
        };
    }

    componentDidMount() {
        const search = window.location.search;
        const params = new URLSearchParams(search);
        this.state.courseId = params.get('courseId');
        this.state.reportName = params.get('reportName');

        this.getReport();
    }

    async getReport() {
        const courseId = this.state.courseId;
        const reportName = this.state.reportName;

        if (!courseId.length || courseId == 0) {
            alert('courseId不能为空');
            return false;
        }
        if (!reportName.length) {
            alert('reportName不能为空');
            return false;
        }

        const url = pcUrl('/aiReport/generate?courseId=' + courseId + '&reportName=' + reportName);
        try {
            const response = await fetch(url,
                {
                    method: 'GET',
                    headers: {
                        'token': CommonValue.get('token')
                    }
                }
            );
            const reader = response.body.getReader();
            const decoder = new TextDecoder();

            while (true) {
                const {done, value} = await reader.read();
                if (done) break;

                const chunk = decoder.decode(value);
                // setData(prev => prev + chunk);
                this.setState({data: this.state.data + chunk})
            }
        } catch (error) {
            console.error('获取报告流异常:', error);
        }
    }

    // copyReport() {
    //     if (!window.confirm("一键复制将会覆盖已有内容，是否继续？")) {
    //         return;
    //     }
    //
    //     let reportText = $("#reportText").html();
    //     if (!reportText) {
    //         return;
    //     }
    //     reportText += "**END**";
    //     console.log(reportText);
    //
    //     const background = this.getSubText(reportText, "**研究背景**", "**研究目的**");
    //     const objective = this.getSubText(reportText, "**研究目的**", "**研究理论**");
    //     const theory = this.getSubText(reportText, "**研究理论**", "**研究过程**");
    //     const process = this.getSubText(reportText, "**研究过程**", "**研究结论**");
    //     const conclusion = this.getSubText(reportText, "**研究结论**", "**参考文献**");
    //     const reference = this.getSubText(reportText, "**参考文献**", "**END**");
    //     const reportInfo = {
    //         'reportName': this.state.reportName,
    //         'background': background,
    //         'objective': objective,
    //         'theory': theory,
    //         'process': process,
    //         'conclusion': conclusion,
    //         'reference': reference,
    //     };
    //     CommonValue.set("reportText", reportInfo);
    //
    //     this.props.history.push("/report1/" + this.state.courseId);
    // }
    //
    // getSubText(reportText, str1, str2) {
    //     const labelLength = 14;
    //     const startIndex = reportText.indexOf(str1) + labelLength;
    //     const endIndex = reportText.indexOf(str2);
    //     return "<p>" + reportText.slice(startIndex, endIndex) + "</p>";
    // }

    render() {
        return (
            <>
                <div className="height-20"></div>
                <div className="body">
                    <div className="report-add-panel">
                        <div className="captain">
                            <h3>
                                智能报告助手
                            </h3>
                        </div>
                        <div className="panel-body">
                            <h4 id="reportText"
                                dangerouslySetInnerHTML={{__html: this.state.data.replace(/\n/g, '<br>')}}/>
                            {/*<h4 id="reportText"*/}
                            {/*    dangerouslySetInnerHTML={{__html: this.state.data}}/>*/}
                        </div>
                        {/*<div className="captain form-submit">*/}
                        {/*    <button className="button button-blue" onClick={() => this.copyReport()}>一键复制</button>*/}
                        {/*</div>*/}
                        <div className="captain" style={{'color': 'red'}}>
                            <h4>请注意：智能报告内容仅供参考，请结合课题内容和自身研究方向进行合理的修改和完善！</h4></div>
                    </div>
                </div>
            </>
        );
    }
}
